<template>
    <header
      class="site-navbar js-sticky-header site-navbar-target"
      role="banner"
    >
      <div class="container">
        <div class="row align-items-center">
          <div class="col-6 col-lg-2"></div>
          <div class="col-12 col-md-10 d-none d-lg-block">
            <nav
              class="site-navigation position-relative text-right"
              role="navigation"
            >
              <ul
                class="site-menu main-menu js-clone-nav mr-auto d-none d-lg-block"
              >
                <li class="active">
                  <a href="/" class="nav-link">Home</a>
                </li>
                <li><a href="#howitworks" class="nav-link">How it works</a></li>
                <li><a href="https://www.monitorbuddy.com/status/69a3bf32-303a-4268-a4b5-71852f2adb4d" target="_blank">API Status</a></li>
                <li><a href="#pricing" class="nav-link">Pricing</a></li>
                <!-- <li><a href="blog.html" class="nav-link">Blog</a></li> -->
                
                <li class="dropdown">
                  <a class="dropdown-toggle" data-toggle="dropdown" href="#">Blog
                  <span class="caret"></span></a>
                  <ul class="dropdown-menu">
                    <li><router-link to="/howtohideapikey" class="dropdown-item">How to hide your API key</router-link></li>
                    <li><router-link to="/getting-started" class="dropdown-item">Getting started</router-link></li>
                   <!-- <li><router-link to="/hide-api-key-from-github" class="dropdown-item">Hide API key from GitHub</router-link></li>-->
                  </ul>
                </li>
                <li><a href="#contact" class="nav-link">Contact</a></li>
              </ul>
            </nav>
          </div>
          <div
            class="col-6 d-inline-block d-lg-none ml-md-0 py-3"
            style="position: relative; top: 3px"
          >
            <a
              href="#"
              class="burger site-menu-toggle js-menu-toggle"
              data-toggle="collapse"
              data-target="#main-navbar"
            >
              <span></span>
            </a>
          </div>
        </div>
      </div>
        
     <div ref="gdprBanner"></div>
    <div class="site-mobile-menu site-navbar-target" style="top:0">
      <div class="site-mobile-menu-header">
        <div class="site-mobile-menu-close mt-3">
          <span class="icofont-close js-menu-toggle"></span>
        </div>
      </div>
      <div class="site-mobile-menu-body"></div>
    </div>

    </header>

</template>
<script>
import BaseNav from "@/components/BaseNav";
import BaseDropdown from "@/components/BaseDropdown";
import CloseButton from "@/components/CloseButton";

export default {
  components: {
    BaseNav,
    CloseButton,
    BaseDropdown
  },
  props: [
      'user'
  ]
};
setTimeout(() => {
  // AOS.init({
  //     easing: 'ease',
  //     duration: 1000,
  //     once: true
  //   });
    (function($) {
  "use strict";

  // Back to top button
  $(window).scroll(function() {
    if ($(this).scrollTop() > 100) {
      $('.back-to-top').fadeIn('slow');
    } else {
      $('.back-to-top').fadeOut('slow');
    }
  });
  $('.back-to-top').click(function() {
    $('html, body').animate({
      scrollTop: 0
    }, 1500, 'easeInOutExpo');
    return false;
  });

  var siteMenuClone = function() {
    $('.js-clone-nav').each(function() {
      var $this = $(this);
      $this.clone().attr('class', 'site-nav-wrap').appendTo('.site-mobile-menu-body');
    });
    setTimeout(function() {
      var counter = 0;
      $('.site-mobile-menu .has-children').each(function() {
        var $this = $(this);
        $this.prepend('<span class="arrow-collapse collapsed">');
        $this.find('.arrow-collapse').attr({
          'data-toggle': 'collapse',
          'data-target': '#collapseItem' + counter,
        });
        $this.find('> ul').attr({
          'class': 'collapse',
          'id': 'collapseItem' + counter,
        });
        counter++;
      });
    }, 2000);
    $('body').on('click', '.arrow-collapse', function(e) {
      var $this = $(this);
      if ($this.closest('li').find('.collapse').hasClass('show')) {
        $this.removeClass('active');
      } else {
        $this.addClass('active');
      }
      e.preventDefault();
    });
    $(window).resize(function() {
      var $this = $(this),
        w = $this.width();
      if (w > 768) {
        if ($('body').hasClass('offcanvas-menu')) {
          $('body').removeClass('offcanvas-menu');
        }
      }
    })
    $('body').on('click', '.js-menu-toggle', function(e) {
      var $this = $(this);
      e.preventDefault();
      if ($('body').hasClass('offcanvas-menu')) {
        $('body').removeClass('offcanvas-menu');
        $('body').find('.js-menu-toggle').removeClass('active');
      } else {
        $('body').addClass('offcanvas-menu');
        $('body').find('.js-menu-toggle').addClass('active');
      }
    })
    // click outisde offcanvas
    $(document).mouseup(function(e) {
      var container = $(".site-mobile-menu");
      if (!container.is(e.target) && container.has(e.target).length === 0) {
        if ($('body').hasClass('offcanvas-menu')) {
          $('body').removeClass('offcanvas-menu');
          $('body').find('.js-menu-toggle').removeClass('active');
        }
      }
    });
  };
  siteMenuClone();
  var siteScroll = function() {
    $(window).scroll(function() {
      var st = $(this).scrollTop();
      if (st > 100) {
        $('.js-sticky-header').addClass('shrink');
      } else {
        $('.js-sticky-header').removeClass('shrink');
      }
    })
  };
  siteScroll();
  var siteSticky = function() {
    $(".js-sticky-header").sticky({
      topSpacing: 0
    });
  };
  siteSticky();
  var siteOwlCarousel = function() {
    $('.testimonial-carousel').owlCarousel({
      center: true,
      items: 1,
      loop: true,
      margin: 0,
      autoplay: true,
      smartSpeed: 1000,
    });
  };
  siteOwlCarousel();

// some time render is slow of email
 setTimeout(() => {
   const text =  $('#first-email-signup-formmc-embedded-subscribe').text();
   if(text) {
     $('.subscribe-container__title').text('')
    $('#first-email-signup-formmc-embedded-subscribe').addClass('icon la la-angle-right')
    $('#first-email-signup-formmc-embedded-subscribe').text('')
    $('#first-email-signup-formmc-embedded-subscribe').closest(".subscribe-container").removeClass('subscribe-container');
   }
  }, 3000);

  $(window).on('load', function() {
    $('.subscribe-container__title').text('')
    $('#first-email-signup-formmc-embedded-subscribe').addClass('icon la la-angle-right')
    $('#first-email-signup-formmc-embedded-subscribe').text('')
    $('#first-email-signup-formmc-embedded-subscribe').closest(".subscribe-container").removeClass('subscribe-container');
  });

})(window.jQuery);

}, 500)


</script>
<style>
</style>
